module.exports = __webpack_public_path__ + "media/images/homes/ReservationandWaitlistManagement-311cd89c804c03cb35008bd1fd7a5068.png";